import styled, { css } from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 99;

    background: #FFF;
    padding: 1rem;
    box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);
    border-radius: 5px;
`

export const ExcelButton = styled.div`
    padding: 0.5rem 1.5rem; 
    border: 1px solid #237344;
    color: #237344;
    border-radius: 0.2rem;

    display: flex;
    align-items: center;

    p{
        font-size: 0.9rem;
        margin-left: 0.2rem;
    }

    ${props => props.fetchingData && css`
        filter: brightness(0.7);
        pointer-events: none;
    `}
`

export const PDFButton = styled.div`
    padding: 0.5rem 1.5rem; 
    border: 1px solid #b40c04;
    color: #b40c04;
    width: 100%;
    border-radius: 0.2rem;

    display: flex;
    align-items: center;

    p{
        font-size: 0.9rem;
        margin-left: 0.2rem;
    }

    ${props => props.fetchingData && css`
        filter: brightness(0.7);
        pointer-events: none;
    `}
`